module.exports = __webpack_public_path__ + "static/img/sec2-cont-img01.a409e51.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/xeogen/sec2-cont-img01.jpg
// module id = ZC7X
// module chunks = 0